module.exports = __webpack_public_path__ + "static/img/cdp.c369cc7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/DOM/FloatMenu/image/cdp.svg
// module id = 394
// module chunks = 0